import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {Eye} from 'core/api/prescription'
import authHeaders from './authHeaders'
import { IErrorResponse } from './error'

export interface IDeleteSubjectPrescriptionPayload {
  activationNotes: string
}

export interface IDeleteSubjectPrescriptionSuccessResponse {
  prescription: {
    /** Prescription id */
    id: string

    /** Timestamp with timezone representing when the prescription was activated. */
    activatedTime: string

    /** Amblyopic eye according to the prescription */
    amblyopicEye: Eye

    /** Flag to determine if this prescription is currently active */
    isActive: boolean,
  }
}


export type IDeleteSubjectPrescriptionResponseBody = IDeleteSubjectPrescriptionSuccessResponse | IErrorResponse;

/**
 * Expected response from DELETE /study/participant/:participantId/prescription endpoint
 */
export interface IDeleteSubjectPrescriptionResponse extends AxiosResponse {
  data: IDeleteSubjectPrescriptionResponseBody
}

export function deletePrescription(token: string, participantId: string, payload: IDeleteSubjectPrescriptionPayload): Promise<IDeleteSubjectPrescriptionResponse> {
  return Client.patch(
    `/study/participant/${participantId}/prescription/deactivate`,
    payload,
    { ...authHeaders(token), validateStatus: () => true },
  )
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/deletePrescription.ts